import { PromotionDto } from "./PromotionDto";

/**
 * Product object
 */
export class ProductDto {
  id: number;
  code?: string;
  name?: string;
  image?: string;
  category?: string;
  sellingPrice?: number;
  newPrice?: number;
  defaultPrice?: number;
  expiredDate?: Date;
  qty?: number;
  brandId?: number;
  weightIncludePackaging?: number;
  promotionList?: Array<PromotionDto>;
}